export const getAlreadyPaidAmount = (existingReservation) => {
    if (!existingReservation?.id) return 0;

    const deposit = Number(existingReservation?.invoice?.deposit);
    if (!Number.isNaN(deposit) && deposit > 0) {
        return Math.max(0, deposit);
    }

    const events = existingReservation?.invoice?.paymentEvent;
    if (!Array.isArray(events) || events.length === 0) return 0;

    return events.reduce((sum, event) => {
        if (event?.status !== "success") return sum;
        return sum + Math.max(0, Number(event?.amount) || 0);
    }, 0);
};

const paymentEventKey = (event) => {
    if (event?.sessionId) return `session:${event.sessionId}`;
    if (event?.paymentIntentId) return `pi:${event.paymentIntentId}`;
    if (event?.refundId) return `refund:${event.refundId}`;
    return "";
};

export const mergePaymentEvents = (existingEvents, incomingEvents) => {
    const merged = [];
    const seen = new Set();

    const append = (events) => {
        if (!Array.isArray(events)) return;
        events.forEach((event) => {
            if (!event || typeof event !== "object") return;
            const key = paymentEventKey(event);
            if (key) {
                if (seen.has(key)) return;
                seen.add(key);
            }
            merged.push({ ...event });
        });
    };

    append(existingEvents);
    append(incomingEvents);
    return merged;
};

export const applyModifyInvoiceAdjustment = (invoice, existingReservation) => {
    if (!invoice || !existingReservation?.id) return invoice;

    const alreadyPaid = getAlreadyPaidAmount(existingReservation);
    const total = Number(invoice?.total) || 0;
    const balance = total - alreadyPaid;
    const due = Math.max(0, balance);
    const extraMoney = Math.max(0, -balance);
    const paymentEvent = mergePaymentEvents(existingReservation?.invoice?.paymentEvent, invoice?.paymentEvent);

    return {
        ...invoice,
        alreadyPaid,
        due,
        extraMoney,
        deposit: alreadyPaid,
        paymentEvent,
        promoCode: existingReservation?.invoice?.promoCode || invoice?.promoCode || [],
    };
};

export const preserveInvoicePaymentHistory = (invoice, existingReservation) => {
    if (!invoice || !existingReservation?.id) return invoice;

    return {
        ...invoice,
        paymentEvent: mergePaymentEvents(existingReservation?.invoice?.paymentEvent, invoice?.paymentEvent),
        promoCode: invoice?.promoCode?.length ? invoice.promoCode : existingReservation?.invoice?.promoCode || [],
    };
};
